import { render, staticRenderFns } from "./SysStatement.vue?vue&type=template&id=ef06b728&xmlns=http%3A%2F%2Fwww.w3.org%2F1999%2Fhtml"
import script from "./SysStatement.vue?vue&type=script&lang=js"
export * from "./SysStatement.vue?vue&type=script&lang=js"
import style0 from "./SysStatement.vue?vue&type=style&index=0&id=ef06b728&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports